import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  list map strategy
export const MapStrategiesList = createSlice({
  name: "MapStrategiesList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_MapStrategiesList: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_MapStrategiesList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_MapStrategiesList: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    MapStrategiesList_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearData: (state) => {
      state.data = [];
    },
  },
});
export default MapStrategiesList.reducer;
export const {
  list_MapStrategiesList,
  success_api_call_MapStrategiesList,
  failure_api_call_MapStrategiesList,
  MapStrategiesList_is_first,
  clearData,
} = MapStrategiesList.actions;
